// Substring that identifies a parse failure in the create resume mutation error.
export const PARSING_RESUME_ERROR_MESSAGE = "Resume parsing error";
